export const pageHref = (page: number, tags: string[] = []) => {
  const base = page <= 1 ? '/blog' : `/blog/page/${page}`
  return tags.length === 0 ? base : `${base}?tags=${tags.join(',')}`
}
